import React, { useState } from 'react';
import { connect, useLocation } from 'umi';
import { Layout } from 'tea-component';
import ContentBody from '@op/components/ContentBody';
import TranslateSelect from '@op/components/SelectComponents/TranslateSelect';
import { singleLanguageSelectOptions } from '@op/components/FilterBoxCommon/constant';
import useLanguage from '@op/hooks/useLanguage';
import useEventDetailsData from './hooks/useEventDetailsData';
import EventContent from './EventContent';
import { IEventItem, TSentimentType, TLanguageType } from './types';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

interface IEventDetailsPageProps {
  gameInfo: Record<string, any>;
  wholeGameInfo: Record<string, any>;
}

function EventDetails({ gameInfo, wholeGameInfo }: IEventDetailsPageProps) {
  const { formatMessage } = useLanguage();
  const location = useLocation();
  const queryParams = (location as any)?.query || {};
  const taskId = queryParams.task_id || '';
  const type = queryParams.type || '';

  // 情感筛选
  const [sentimentType, setSentimentType] = useState<TSentimentType>('total');
  // 语种选择
  const [languageType, setLanguageType] = useState<TLanguageType>('origin');
  // 选中事件 — UI 层状态，与数据获取分离
  const [selectedEvent, setSelectedEvent] = useState<IEventItem | null>(null);

  // 数据 Hook — 调用 advanced/event_list 获取列表
  const {
    eventList,
    listLoading,
    startTime,
    endTime,
  } = useEventDetailsData({
    taskId,
    sentimentType,
  });

  return (
    <Content className="dbo-eventdetails">
      <ContentBody
        contentHeard={
          <Content.Header
            showBackButton
            onBackButtonClick={() => window.history.back()}
            title={
              <div className="dbo-header-title">
                {formatMessage({ id: PAGE_NAME.EVENT_DETAILS })}
              </div>
            }
          >
          </Content.Header>
        }
      >
        <div className="dbo-eventdetails-header">
          <TranslateSelect
            isSingle
            langOptions={singleLanguageSelectOptions}
            lang={languageType}
            getChange={(value: TLanguageType) => setLanguageType(value)}
          />
        </div>
        <EventContent
          eventList={eventList}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          listLoading={listLoading}
          languageType={languageType}
          gameInfo={gameInfo}
          sentimentType={sentimentType}
          setSentimentType={setSentimentType}
          wholeGameInfo={wholeGameInfo}
          startTime={startTime}
          endTime={endTime}
          taskId={taskId}
          type={type}
        />
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(EventDetails);
